import { PropsWithChildren } from 'react'
import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'
import { getNonce } from './nonce'

const cache = createCache({ key: 'css', nonce: getNonce() })

export function EmotionNonceProvider({ children }: PropsWithChildren<{}>) {
  return <CacheProvider value={cache}>{children}</CacheProvider>
}
